import { FC } from 'react';
import { Flex, SimpleGridProps } from '@chakra-ui/react';

export const HomeCardContainer: FC<SimpleGridProps> = (props) => <Flex wrap="wrap" gap={8} {...props} />;
